import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CancelTokenSource } from "axios";
import { debounce } from "lodash";
import moment from "moment";

import api from "@/services/api.service";

import { DeviceSearchResult } from "@/store/devices/types";

const VideoReportingStore = namespace("videoReporting");

@Component
export default class DeviceSearchMixin extends Vue {
	public deviceSearchToken: CancelTokenSource = null;
	public devices: DeviceSearchResult[] = [];

	@VideoReportingStore.Getter("getMaxDurationPref") public maxClipDurationLimit: number;

	/**
	 * Formats date for the calendar input.
	 */
	public calendarDateFormatter(date: string) {
		return moment(date).format("MM/DD/YYYY");
	}

	/**
	 * Configures the calendar to disable selection of dates in the future.
	 */
	public get calendarDisabledDates() {
		let today = new Date();
		today.setHours(23, 59, 59);

		return {
			from: today
		};
	}

	/**
	 * De-bounced function which performs a device search, cancelling any
	 * previous requests.
	 */
	private debouncedSearch = debounce(
		async function(searchText, loading) {
			if (this.deviceSearchToken) {
				this.deviceSearchToken.cancel();
			}

			if (searchText.length == 0) {
				this.devices = [];
			}

			let { data } = await api.deviceSearchAll(searchText, this.deviceSearchToken);
			this.devices = data;

			loading(false);
		},
		300,
		{ leading: false, trailing: true }
	);

	/**
	 * Handler for when the user starts typing in the device dropdown.
	 */
	public async onDeviceSearch(searchText: string, loading: (isLoading: boolean) => void) {
		loading(true);

		await this.debouncedSearch(searchText, loading);
	}
}
